import { CSSProperties } from "react";

export const content: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  gap: "16px",
  marginBottom: "12px",
};

export const icon: CSSProperties = {
  width: "24px",
  height: "24px",
  color: "#E84749",
  order: 1,
};

export const iconImg: CSSProperties = {
  paddingTop: "1px",
  paddingLeft: "1px",
  fontSize: "22px",
};

export const colorError: CSSProperties = {
  color: "rgba(323, 71, 73, 1)",
};

export const colorInfo: CSSProperties = {
  color: "rgba(22, 119, 255, 1)",
};

export const colorWarning: CSSProperties = {
  color: "rgba(216, 150, 20, 1)",
};

export const messageContainer: CSSProperties = {
  whiteSpace: "pre-line",
  order: 2,
};

export const title: CSSProperties = {
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "16px",
  lineHeight: "24px",
};

export const message: CSSProperties = {
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "22px",
  marginTop: "8px",
};

export const detail: CSSProperties = {
  marginTop: "16px",
  color: "var(--avengers-text-color)",
  opacity: 0.5,
};

export const texts: CSSProperties = {
  color: "var(--avengers-text-color)",
};

